/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { Banner } from '@cox/core-ui8/dist/Banner'

import { INVERSION_PAGE_TYPES } from '../../constants'
import { useInversionData } from '../../hooks/useInversionData'
import { DynamicMediaComponents, getDynamicMedia } from '../../utils/dynamic-media-util'
import { getTokenValues } from '../../utils/rule-builder-util'
import { getSpacing } from '../../utils/spacing-util'
import { ReactBannerProps } from '../ReactBanner'
import IsInEditorText from '../shared/IsInEditorText'

const ReactBanner = (props: ReactBannerProps): JSX.Element => {
  const {
    bannerType,
    isInEditor = false,
    bannerId = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    iconPath = '',
    altIcon = '',
    message = '',
    buttonStates,
    linkText,
    openInNewTab,
    link,
    linkUrl,
    linkId,
    linkType,
    fileName,
    tokenProperties,
    variations,
    text,
    simplified,
    icon,
    anchor,
    chatText,
    isDismissable = false
  } = props

  const imgSrc = (iconPath && getDynamicMedia(iconPath, DynamicMediaComponents.BANNER, fileName)) || iconPath
  const altIconText = (getTokenValues(altIcon, tokenProperties) as string) || ''
  const linkMsg = text || linkText
  const inversionItems = useInversionData()
  const { appData } = useAppDataContext()
  const { pageType = '', isInversion = false } = appData?.page ?? {}
  const firstItem = inversionItems?.[0] ?? {}
  const { property_name_display = '', directions_link = '' } = firstItem
  const isInversionLogic = isInversion === 'true' && pageType.includes(INVERSION_PAGE_TYPES.communities)

  const messageToBeDisplayed = isInversionLogic ? property_name_display : message
  const bannerLink = isInversionLogic ? directions_link ?? '#' : link || linkUrl

  return (
    <div
      data-testid={`react-banner-container`}
      className={`react-banner-container ${getSpacing(top, right, bottom, left)} ${lob}`}
      id={bannerId}
    >
      {IsInEditorText(isInEditor, 'React Banner')}
      <Banner
        bannerType={bannerType}
        message={messageToBeDisplayed}
        buttonStates={buttonStates}
        linkText={linkMsg}
        openInNewTab={openInNewTab}
        linkUrl={bannerLink}
        linkId={linkId}
        //@ts-ignore
        linkType={linkType}
        iconPath={imgSrc}
        altIcon={altIconText}
        variation={variations}
        simplified={simplified}
        buttonIcon={icon}
        anchor={anchor}
        chatText={chatText}
        isDismissable={isDismissable}
      />
    </div>
  )
}
export default ReactBanner
